import i18n from 'i18next';

import getIsSocialAppEnabled from '../helpers/getIsSocialAppEnabled';
import getIsSocialFeatureEnabled from '../helpers/getIsSocialFeatureEnabled';

export default ({ adminSettings, isInLiveMode, isChildLocale = false }) => {
  if (isChildLocale) return {};

  const isSocialDisabled = !getIsSocialAppEnabled({ adminSettings });
  const qaIsDisabled = !getIsSocialFeatureEnabled({ adminSettings, feature: 'Community' });
  const chatIsDisabled = !getIsSocialFeatureEnabled({ adminSettings, feature: 'Chat' });

  return {
    ...(isSocialDisabled && {
      social_upsell: {
        type: 'PropertiesUpsell',
        isDecoration: true,
        title: i18n.t('social-upsell-title'),
        description: i18n.t('social-upsell-description'),
        icon: 'socialUpsell',
      },
    }),
    ...((isSocialDisabled || qaIsDisabled) && {
      community_disabled_info: {
        type: 'Warning',
        isDecoration: true,
        text: i18n.t('q_and_a-disabled-info'),
        icon: 'info',
        iconSize: 18,
      },
    }),
    community_enabled: {
      type: 'Radio',
      label: i18n.t('q_and_a-access'),
      help: i18n.t('q_and_a-access-help'),
      options: [
        { label: i18n.t('q_and_a-enabled'), value: true, isDisabled: qaIsDisabled },
        { label: i18n.t('q_and_a-disabled'), value: false, isDisabled: qaIsDisabled },
      ],
    },
    ...(isInLiveMode && {
        tribe_chat_enabled: {
          type: 'Radio',
          label: i18n.t('social-chat'),
          help: i18n.t('social-chat-help'),
          options: [
            { label: i18n.t('chat-enabled'), value: true, isDisabled: chatIsDisabled },
            { label: i18n.t('chat-disabled'), value: false, isDisabled: chatIsDisabled },
          ],
        },
      }),
  };
};
